// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormNote } from '~/utils/interface/note';
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormSettingGoal } from '~/utils/interface/goal';

export const schema = (t: TFunction): yup.ObjectSchema<IFormSettingGoal> => {
  return yup.object().shape({
    commissionCost: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    revenueCost: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
  });
};

export const defaultValuesForm: IFormSettingGoal = {
  commissionCost: EMPTY_STRING,
  revenueCost: EMPTY_STRING,
};
